/** Storefront (customer site) branding */
export const STOREFRONT_BRAND = {
  logo: '/img/bodywonLogo.png',
  favicon: '/img/bodywonLogo.png',
  title: 'BodyWon',
};

/** Admin panel branding */
export const ADMIN_BRAND = {
  logoIcon: '/img/logo.png',
  logoTitle: 'Comm',
  favicon: '/img/logo.png',
  title: 'Ai Comm Admin',
};
